<template>
  <patientComponent :hireState="3"></patientComponent>
</template>
<script>

import patientComponent from '@/components/fetalMonitor/patient.vue'
export default {
  name: `fetalMonitornewAddition`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    patientComponent
  }
}
</script>

<style lang="scss" scoped>
</style>